import React, { useState, useEffect } from 'react';
import { Button } from './components/ui/button';
import { Card, CardContent } from './components/ui/card';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after 1 second
      setTimeout(() => setShow(true), 1000);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShow(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie-consent-overlay" data-testid="cookie-consent">
      <Card className="cookie-consent-card">
        <button 
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
          onClick={declineCookies}
          aria-label="Chiudi"
        >
          <X className="w-5 h-5" />
        </button>
        
        <CardContent className="pt-6">
          <h3 className="text-xl font-bold mb-3">🍪 Cookie e Privacy</h3>
          <p className="text-gray-700 mb-4">
            Utilizziamo cookie tecnici necessari per il funzionamento del sito (carrello, navigazione). 
            Non utilizziamo cookie di profilazione o tracciamento.
          </p>
          <p className="text-sm text-gray-600 mb-4">
            Continuando la navigazione accetti l'uso dei cookie tecnici. 
            Leggi la nostra <Link to="/privacy-policy" className="text-primary underline hover:text-primary-dark">Privacy Policy</Link> per maggiori informazioni.
          </p>
          <div className="flex gap-3 flex-wrap">
            <Button onClick={acceptCookies} data-testid="accept-cookies">
              Accetta
            </Button>
            <Button variant="outline" onClick={declineCookies} data-testid="decline-cookies">
              Rifiuta
            </Button>
            <Button variant="ghost" asChild>
              <Link to="/privacy-policy">Leggi Privacy Policy</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};